/* eslint max-classes-per-file: 0 */

import {
  LkUser as Data,
  LkUserCollection as Collection,
  UserContacts,
} from '@/typings/api/User'

import { Fabric } from '@/store/createCrudModule'
import { LKProfilesAdapter } from './LKProfilesAdapter'
import {
  AteRegionsApi,
  AteMunicipalitiesApi,
  AteSchoolsApi,
  UsersApi,
} from '@/api/resources'

export const fabric = Fabric<Data, Collection>()

type S = LKProfileState
type G = LKProfileGetters
type M = LKProfileMutations
type A = LKProfileActions


export class LKProfileState extends fabric.State {
  public profile: Data | null = null;

  public info: unknown | null = null;

  public permissions: Data | null = null;
}

export class LKProfileGetters extends fabric.Getters<S> {
}

export class LKProfileMutations extends fabric.Mutations<S> {
  public setProfile(payload: Data) {
    this.state.profile = payload
  }

  public setInfo(payload: unknown) {
    this.state.info = payload
  }

  public setPermissions(payload: Data) {
    this.state.permissions = payload
  }
}

export class LKProfileActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new LKProfilesAdapter();

  protected readonly usersApi = new UsersApi();

  protected readonly idName = 'id';

  public async getCurrent() {
    const { data: profile } = await this.adapter.api.current()

    this.mutations.setProfile(profile)

    let api
    let id

    if (profile.region_id) {
      api = new AteRegionsApi()
      id = profile.region_id
    } else if (profile.municipality_id) {
      api = new AteMunicipalitiesApi()
      id = profile.municipality_id
    } else if (profile.school_id) {
      api = new AteSchoolsApi()
      id = profile.school_id
    }

    if (api && id) {
      const { data: info } = await api.info(id)
      this.mutations.setInfo(info)
    }
  }

  public async getPermissions() {
    const { data } = await this.adapter.api.permissions()
    this.mutations.setPermissions(data)
  }

  public async updateCurrentContacts({ payload }: { payload: UserContacts }) {
    await this.usersApi.updateCurrentContacts(payload)
  }
}
